export default "__VITE_ASSET__UHrlm4Uk__"